import React from 'react';

import {observer} from 'mobx-react';
import AutoAwesomeIcon from '@mui/icons-material/AutoAwesome';

import LimitedTextField from '../../Shared/LimitedTextField';
import GradientIcon from '../../Generic/GradientIcon';

const labelClass = 'text-[11px] font-semibold text-main-normal tracking-[0.5px]';
const wrapClass = 'block w-full box-border px-3 py-2 rounded-lg border border-panels-normal transition-colors focus-within:border-classic-button-normal focus-within:border-2 focus-within:px-[11px] focus-within:py-[7px]';
const textareaClass = 'w-full block bg-transparent border-0 outline-none resize-none text-sm text-main-normal box-border';

const SummarizeButton = ({onGenerate, isGenerating}) => (
    <button
        onClick={onGenerate} disabled={isGenerating}
        style={{display: 'flex', alignItems: 'center', gap: 4, background: 'none', border: 'none', cursor: isGenerating ? 'default' : 'pointer'}}
    >
        <GradientIcon firstColor="#5B19B4" secondColor="#004FFF" gradientId="aiSettingsColors" disabled={!isGenerating}>
            <AutoAwesomeIcon style={{fontSize: 16}} sx={{fill: isGenerating ? '#7f7f7f' : 'url(#aiSettingsColors)'}} />
        </GradientIcon>
        <span style={{
            fontSize: 13, fontWeight: 500,
            ...(isGenerating
                ? {color: '#7f7f7f'}
                : {background: 'var(--gradient-purple-blue)', WebkitBackgroundClip: 'text', WebkitTextFillColor: 'transparent'}),
        }}>
            Summarize with AI
        </span>
    </button>
);

const AIInstructionsSection = observer(({value, onChange, onGenerate, isGenerating, originalValue}) => (
    <div>
        <div className="flex items-center justify-between mb-1">
            <label className={labelClass}>
                AI INSTRUCTIONS <span className="text-main-hover font-normal">(optional)</span>
            </label>
            <SummarizeButton onGenerate={onGenerate} isGenerating={isGenerating} />
        </div>
        <div className={wrapClass}>
            <LimitedTextField
                className={textareaClass}
                placeholder={!isGenerating ? 'Add AI instructions...' : 'Summarizing'}
                value={value}
                onChange={(e) => onChange(e.target.value)}
                minRows={3}
                maxRows={4}
                multiline
                readOnly={false}
                isTextAreaAutoSize
                originalValue={originalValue}
                limit={4000}
            />
        </div>
    </div>
));

export default AIInstructionsSection;
